import { connect } from 'react-redux';
import { firebaseConnect, dataToJS, isLoaded, pathToJS } from 'react-redux-firebase';
import NewSection from './component';

const fbWrap = firebaseConnect(['rows', 'sections', 'tables'])(NewSection);

export default connect(({ firebase }, { sectionTitle }) => {
  const allTables = dataToJS(firebase, 'tables', {});
  const allSections = dataToJS(firebase, 'sections', {});
  const auth = pathToJS(firebase, 'auth');
  let sectionId = null;
  const tables = [];

  Object.keys(allSections).forEach((key) => {
    if (allSections[key].title === sectionTitle) { sectionId = key; }
  });

  Object.keys(allTables).forEach((key) => {
    if (allTables[key].sectionId === sectionId) {
      const columns = (!isLoaded(auth) || !auth) ? [] : [{ dataType: 'id', title: 'id' }];
      tables.push({
        id: key,
        columns: [...Object.values(allTables[key].columns).filter(col => col), ...columns],
        title: Object.values(allTables[key].title),
      });
    }
  });

  const allEntries = dataToJS(firebase, '/rows') || {};
  const rows = [];
  tables.forEach((table) => {
    const rowValues = [];
    Object.keys(allEntries).forEach((key) => {
      if (allEntries[key].tableId === table.id) {
        rowValues.push({ ...allEntries[key].values, id: key });
      }
    });

    rows[table.id] = rowValues;
  });

  return {
    tables,
    sectionId,
    rows,
  };
})(fbWrap);



// WEBPACK FOOTER //
// ./src/modules/NewSection/container.js